import React, { useRef } from 'react';
import { Upload, X, Loader2 } from 'lucide-react';

export default function ImageUploader({
  label,
  currentUrl,
  onUpload,
  onRemove,
  uploading,
  hint,        // e.g. "1280 × 720 px recommended (16:9)"
  aspectClass, // tailwind class for aspect ratio wrapper
}) {
  const inputRef = useRef();

  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-slate-700 mb-1">{label}</label>
      )}

      {currentUrl ? (
        /* ── Preview: always show FULL image, no crop ── */
        <div className="relative rounded-lg border border-slate-200 overflow-hidden bg-slate-50">
          <img
            src={currentUrl}
            alt="preview"
            className="w-full h-auto block"   /* h-auto = natural height, no crop */
            style={{ maxHeight: 340, objectFit: 'contain', background: '#f8f8f8' }}
          />
          <button
            type="button"
            onClick={onRemove}
            className="absolute top-2 right-2 bg-red-600 hover:bg-red-700 text-white rounded-full p-1.5 shadow-lg transition-colors"
          >
            <X size={14} />
          </button>
        </div>
      ) : (
        /* ── Upload zone ── */
        <div
          onClick={() => !uploading && inputRef.current?.click()}
          className={`border-2 border-dashed rounded-lg text-center cursor-pointer transition-colors
            ${uploading
              ? 'border-blue-300 bg-blue-50'
              : 'border-slate-300 hover:border-red-400 hover:bg-red-50'
            }`}
          style={{ padding: '28px 16px' }}
        >
          {uploading ? (
            <div className="flex flex-col items-center gap-2 text-blue-500">
              <Loader2 size={28} className="animate-spin" />
              <span className="text-sm font-medium">Uploading...</span>
            </div>
          ) : (
            <div className="flex flex-col items-center gap-2 text-slate-400">
              <Upload size={28} />
              <span className="text-sm font-semibold text-slate-600">Click to select image</span>
              <span className="text-xs text-slate-400">JPG, PNG, WEBP • Max 5 MB</span>
              {/* Recommended size hint */}
              {hint && (
                <span className="mt-1 text-xs font-semibold text-red-500 bg-red-50 border border-red-200 rounded px-3 py-1">
                  📐 {hint}
                </span>
              )}
            </div>
          )}
        </div>
      )}

      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={e => e.target.files?.[0] && onUpload(e.target.files[0])}
      />
    </div>
  );
}
